





















import { Component, Vue, Watch } from 'vue-property-decorator'

@Component({})
export default class SystemMemoryChart extends Vue {
  ready = false

  get chartData () {
    return this.$store.state.charts.memory || []
  }

  get options () {
    const o = {
      ...this.$store.getters['charts/getBaseChartOptions']({
        memused: '%'
      }),
      series: this.series
    }
    return o
  }

  get series () {
    return this.$store.getters['charts/getBaseSeries']({
      name: 'memory used',
      encode: { x: 'date', y: 'memused' }
    })
  }

  @Watch('chartData', { immediate: true })
  onChartData (data: any) {
    if (data && data.length > 0) this.ready = true
  }
}
